// extracted by mini-css-extract-plugin
export default {"tabs":"TabsBar_tabs__NyYPN"};